var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('el-container',[(_vm.top_disp==true)?_c('el-header',[_c('homeTop')],1):_vm._e(),_c('el-main',[_c('router-view',{staticClass:"content"})],1),(_vm.bottom_disp==true)?_c('el-footer',[_c('homeBottom')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }